import { $i18n_specs, I18NSpec } from '../../config/i18n';
import { $vars } from '../../config/vars';
import { $storage } from './storage';
import { YId } from './types';

export type YLanguage = 'en' | 'sv' | 'es' | 'ca' | 'fr' | 'de';

export let $i18n: I18NSpec;

declare global {
    interface Window {
        y_language?: YLanguage;
        y_language_set?: boolean;
    }
}

export type YI18NString = { [lang in YLanguage]?: string };
export type YI18NStrings = { [lang in YLanguage]?: string[] };
export type YI18NId = { [lang in YLanguage]?: YId };

export let the_language: YLanguage;

export const y_language_names: { [lang in YLanguage]: string } = {
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    sv: 'Svenska',
    ca: 'Català',
    fr: 'Français'
}

function doSetLanguage(l: YLanguage) {
    the_language = l;
    $i18n = $i18n_specs[l] || $i18n;
}

export function ySetLanguage(l: YLanguage, store?: boolean, persist?: boolean) {
    if(l === the_language) return true;
    if(!$vars.supported_languages.includes(l)) return false;
    doSetLanguage(l);
    if(store)
        $storage.putString("buola_language", window.y_language, persist)
    return true;
}

export function ySetLanguageOneOf(ls: YLanguage[]) {
    if(ls.includes(the_language)) return true;
    for(let l of ls) {
        if(ySetLanguage(l)) return true;
    }
    return false;
}

doSetLanguage($vars.default_language);
const stored = $storage.getString("buola_language");

if(window.y_language && (!stored || window.y_language_set)) {
    ySetLanguage(window.y_language, window.y_language_set);
} else if(stored) {
    ySetLanguage(stored as YLanguage);
} else {
    for(let l of navigator.languages) {
        if(ySetLanguage(l.split('-')[0] as YLanguage)) break;
    }
}

export function yLanguageCompare(a: YLanguage, b: YLanguage): number {
    if(a === b) return 0;
    if(a === the_language) return -1;
    if(b === the_language) return 1;
    if(a === 'en') return -1;
    if(b === 'en') return 1;
    return a < b ? -1 : 1;
}

export function yGetI18Ns(s?: YI18NStrings): string[] {
    return s && (s[the_language] || s.en || s.sv || s.de) || [];
}

export function yGetI18N(s?: YI18NString): string {
    return s && (s[the_language] || s.en || s.sv || s.de) || '';
}

export function yGetI18NsIn(s: YI18NStrings | undefined, l: YLanguage): string[] {
    return s && (s[l] || s.en || s.sv || s.de) || [];
}

export function yGetI18NIn(s: YI18NString | undefined, l: YLanguage): string {
    return s && (s[l] || s.en || s.sv || s.de) || '';
}

export function yIsEmptyI18N(s?: YI18NString): boolean {
    return !s || !Object.values(s).some(v => v);
}

export function yIsEmptyI18Ns(s?: YI18NStrings): boolean {
    return !s || !Object.values(s).some(v => v && v.length);
}

export function yInterpolate(pattern: string, ...args: (string | number)[]): string
export function yInterpolate(pattern: string) {
    for(let i = 1; i <= arguments.length; i++) {
        pattern = pattern.replaceAll('$' + i + '$', arguments[i]);
    }

    return pattern;
}

export function yPlural(amount: number, singular: string, plural: string, show_number?: boolean) {
    const which = amount == 1 ? singular : plural;
    if(show_number !== false)
        return amount + ' ' + which;
    else
        return which;
}

